import React, { useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";

const AdminNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ เพิ่ม
  const { user, logout } = useAuth();

  const username = user?.username;
  const avatar = user?.avatar || "https://i.pravatar.cc/100?img=12";
  const profileToggleRef = useRef(null);

  // ✅ path ที่ต้องการ bg-gradient-info
  const GRADIENT_PATHS = ["/index", "/submenu-product-service"];
  const isGradient =
    GRADIENT_PATHS.includes(location.pathname);

  return (
    <Navbar
      expand="md"
      id="navbar-main"
      className={`navbar-top navbar-dark ${
        isGradient ? "bg-gradient-info" : ""
      }`}
    >
      <Container fluid>
        <Link
          className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
          to="/"
        />

        {/* 🔔 Notification */}
        <Nav
          className="align-items-center d-none d-md-flex ml-lg-auto"
          navbar
        >
          <UncontrolledDropdown nav>
            <DropdownToggle
              nav
              className="nav-link-icon"
              onClick={(e) => e.preventDefault()}
            >
              <i className="ni ni-bell-55" />
            </DropdownToggle>
          </UncontrolledDropdown>
        </Nav>

        {/* 👤 Profile */}
        <Nav className="align-items-center d-none d-md-flex" navbar>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav className="p-0" innerRef={profileToggleRef}>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt={username}
                    src={avatar}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </span>
                <Media className="ml-2 d-none d-sm-block">
                  <span className="mb-0 text-sm font-weight-bold">
                    {username}
                  </span>
                </Media>
              </Media>
            </DropdownToggle>

            <DropdownMenu right className="dropdown-menu-arrow">
              <DropdownItem tag={Link} to="/user-profile">
                <i className="ni ni-single-02" />
                <span>ข้อมูลส่วนตัว</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={logout}>
                <i className="ni ni-button-power mr-2" />
                <span>ออกจากระบบ</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AdminNavbar;
